<div class="landing-container">
  <video autoplay muted>
    <source src="assets/bg2.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  <div class="right-side">
    <div class="card">
      <img src="assets/fintech-logo.png" alt="Logo" class="logo" />
      <h1>Welcome to FinTech Init</h1>
      <p>This is a finance managing system.</p>
      <p>Primary use is overview of accounts and mappings.</p>
      <span>Please click the button below to login.</span>
      <button (click)="loginRedirect()" class="login-btn">LOG IN</button>
    </div>
  </div>
</div>